module.exports = __webpack_public_path__ + "img/linkedin.db258b08.png";